/**
 * Import required libraries
 */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { labelFromPath } from "Utils";

/**
 * Import required elements
 */
// Material-ui components
import { TextField, Button } from "@material-ui/core";
import TopBar from "./TopBar";
import Message from "./Message";
import ButtonPopup from "../ButtonPopup";
import EmojiBoard from "./EmojiBoard";
// Material-ui icons
import EmojiIcon from "@material-ui/icons/InsertEmoticonSharp";
import styles from "./styles.js";

/**
 * ChatBox Render JSX
 */
const ChatBoxDiv = ({
  lang,
  labelPath,
  uid,
  title,
  messages,
  input,
  onChange,
  user,
  sendMessage,
  scrollRef,
  children,
  emojiProps
}) => {
  
  const _label = key => labelFromPath(labelPath, key, lang);

  useEffect(() => {
    if (scrollRef.current && scrollRef.current.scrollTop !== undefined) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [scrollRef, messages])

  // CSS classnames
  const classes = styles();

  let prevUserUid = null;

  return (
    <div className={classes.defaultChatBox}>
      <TopBar title={title} uid={uid} />

      <div className={classes.Messages} ref={scrollRef}>
        {messages.map(({message, pseudo, uid, userUid}, index) => {
          const mine = user.userUid === userUid;
          let content = (
            <Message key={uid}
              uid={uid}
              userUid={userUid}
              mine={mine}
              fromNew={prevUserUid !== userUid}
              pseudo={mine ? null : (prevUserUid !== userUid ? pseudo : null)}
              message={message}
            />
          );
          prevUserUid = userUid;
          return content;
        })}
      </div>

      <form className={classes.Form} onSubmit={sendMessage}>
        <ButtonPopup {...emojiProps}
          Popup={EmojiBoard}
          Icon={EmojiIcon}
          buttonStyle={{marginBottom: 20}}
        />
        <TextField className={classes.textField}
          label={_label("message")}
          type="text"
          value={input}
          onChange={onChange}
        />
        <Button
          className={classes.submit}
          type="submit"
          size="small"
          variant="contained"
          color="primary"
        >
          {_label("send")}
        </Button>
      </form>
    </div>
  );
};

export default connect((state, {messages}) => {
  return {
    messages: messages
      .filter(uid => uid in state.list.message)
      .map(uid => state.list.message[uid])
      .sort((msgA, msgB) => msgA.createdAt-msgB.createdAt)
  }
})(ChatBoxDiv);
